/** @jsx jsx */
import PropTypes from 'prop-types';
import React from 'react';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import { Icon } from '../../ui/Icon';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import getComponent from '../../../utils/getComponent';
import { COMPONENT_NAMES } from '../../../utils/constants';
import { processLinkData } from '../../../utils/analytics';
import * as styles from './index.styles';

const defaultLabel = 'CallUsOn';

export const getContactLineDataFromContext = sitecoreContext => {
  const fields =
    getComponent(sitecoreContext, COMPONENT_NAMES.navBar) ||
    getComponent(sitecoreContext, COMPONENT_NAMES.enquiryModal);
  return get(fields, 'placeholders["jss-phone"][0]');
};

export class ContactLineNumber extends SafePureComponent {
  /**
   * render the label of the phone, the default value is defined in {defaultLabel}
   * @return {React.Node}
   */
  renderlabel = () => {
    const { t, label } = this.props;
    return (
      <span className="phone-label" css={styles.openStatus}>
        {t(label)}
      </span>
    );
  };

  /**
   * validate what kind of icon should be rendered based on the alternateIcon param
   * @return {React.Node}
   */
  renderIcon = () => {
    const {
      params: { alternateIcon },
    } = this.props;
    return alternateIcon ? (
      <i className="icon-phone phone-alternate-icon" />
    ) : (
      <Icon name="contact" className="phone-default-icon" />
    );
  };

  processGTMData = () => {
    const { t, params, label } = this.props;
    const fieldCta = {
      value: { text: t(label) },
    };
    processLinkData(params.componentName, fieldCta, true);
    return true;
  };

  safeRender() {
    const { props } = this;
    const phoneNumber = get(props, 'fields.CountryPhone.value');
    const { params } = props;
    const { isSecondaryType } = params;
    return (
      <React.Fragment>
        {isSecondaryType && this.renderlabel()}
        <a
          id={params.phoneNumberId}
          className="phone-container"
          css={styles.contactLineNumber}
          href={`tel: ${phoneNumber}`}
          onClick={this.processGTMData}
        >
          {this.renderIcon()}
          {!isSecondaryType && this.renderlabel()}
          <span className="phone-number" dir="ltr">
            {phoneNumber}
          </span>
        </a>
      </React.Fragment>
    );
  }
}

ContactLineNumber.displayName = 'ContactLineNumber';

ContactLineNumber.defaultProps = {
  fieldNumber: '',
  isTextEditable: false,
  label: defaultLabel,
  params: {},
  isSecondaryType: false,
};

ContactLineNumber.propTypes = {
  fieldNumber: PropTypes.oneOfType([
    PropTypes.shape({ value: PropTypes.string }),
    PropTypes.string,
  ]),
  isTextEditable: PropTypes.bool,
  label: PropTypes.oneOf([defaultLabel, 'OpenStatus']),
  params: PropTypes.object,
  isSecondaryType: PropTypes.bool,
};

export default withNamespaces()(ContactLineNumber);
